var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.teamY.id == _vm.teamX.id)?_c('span',[_c('i',{staticClass:"fas fa-times"})]):(_vm.match != null && _vm.match.isStarted)?_c('span',{on:{"click":_vm.reset}},[_vm._v("\n  "+_vm._s(_vm.scoreX)+":"+_vm._s(_vm.scoreY)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }